<template>
  <button @click="$emit('click')" :class="css">{{ label }}</button>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    css() {
      let classes = "btn btn-block btn-card text-capitalize "
      if (this.status) {
        classes += "btn-green"
      } else {
        classes += "btn-primary"
      }
      return classes
    },
    label() {
      return this.status ? "Selected" : "Select"
    }
  }
}
</script>  
